import firebase from 'firebase/app';
import { FirebaseTracker } from '@dpdgroupuk/react-event-tracker';

export default new FirebaseTracker(firebase, {
  projectRef: 'FMC',
  debug: process.env.NODE_ENV === 'development',
});
